module.exports = __webpack_public_path__ + "static/media/quiz-arrow-left.f8247902.svg";